import { useState } from "react";
import { ETimeSlot } from "@modules/eirCustomersFacade/interfaces/models/IAvailableAppointmentDate";
import { patchUpdateAppointment } from "@modules/eirCustomersFacade/api";
import { useFetchState } from "@hook/useFetchState";
import { IAppointment } from "@modules/eirCustomersFacade/interfaces/models/IAppointment";
import { mapUpdateAppointmentPayload } from "@modules/eirCustomersFacade/mappers/mapUpdateAppointmentPayload";
import { KeyedMutator } from "swr";

interface IParams {
    mutate: KeyedMutator<IAppointment[]>;
}

export const useAppointment = (props: IParams) => {
    const { mutate } = props;

    const {
        startFetching,
        endFetching,
        isLoading: isUpdateAppointmentLoading,
        error: updateAppointmentError,
    } = useFetchState();

    const [selectedAppointment, setSelectedAppointment] = useState<IAppointment>();
    const [dateValue, setDateValue] = useState<string>("");
    const [timeSlotValue, setTimeSlotValue] = useState<ETimeSlot>(ETimeSlot.AM);

    const handleOpenRescheduleModal = (appointment: IAppointment) => {
        setSelectedAppointment(appointment);
    };

    const handleUpdateAppointment = async (appointment: IAppointment) => {
        try {
            startFetching();
            const payload = mapUpdateAppointmentPayload(dateValue, timeSlotValue);
            await patchUpdateAppointment(appointment.id, payload).then(() => {
                setSelectedAppointment(undefined);
                mutate();
            });
            endFetching();
        } catch (error) {
            endFetching(error);
        }
    };

    const handleCloseRescheduleModal = () => {
        setSelectedAppointment(undefined);
        endFetching();
    };

    return {
        handleUpdateAppointment,
        handleOpenRescheduleModal,
        handleCloseRescheduleModal,
        isUpdateAppointmentLoading,
        updateAppointmentError,
        selectedAppointment,
        dateValue,
        setDateValue,
        timeSlotValue,
        setTimeSlotValue,
    };
};
